module.exports = __webpack_public_path__ + "img/multi-package-yellow.c19e676d.svg";